import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";

import Select from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Tag } from "primereact/tag";
import mapEtatFicheDem from "../mapEtatFicheDem";
import FicheLogTerminal from "./journal";
import { TextField, TextareaAutosize } from "@mui/material";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import formatToISODate from "../formatDateISO";
import formatDate from "../formatDate";

import { Dropdown } from "primereact/dropdown";
import { MicNone } from "@mui/icons-material";

import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import { Calendar } from "primereact/calendar";

import convertTimeStringToDate from "../timeToDate";

import formatDateTimeMadagascar from "../convertTime";

import {
  formatDateWithDaysAgo,
  clientTemplate,
  contactTemplate,
  invitesTemplate,
  typeTemplate,
  nameTemplate,
  phoneTemplate,
  emailTemplate,
  amountTemplate
} from '../formatTableau';



const apiUrl = process.env.REACT_APP_API_URL;
export default function Toutes({ searchTerm = "" }) {
  const [loading, setLoading] = useState(true);

  const [editMode, setEditMode] = useState(false);

  const [ficheToutes, setFicheToutes] = useState([]);
  const [users, setUsers] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState("");

  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [visible, setVisible] = useState(false);

  const [rechercheToutes, setRechercheToutes] = useState("");
  const [rechercheId, setRechercheId] = useState("");

  const [tempIdFicheDem, setTempIdFicheDem] = useState("");

  const [tempNom, setTempNom] = useState("");
  const [tempEmail, setTempEmail] = useState("");
  const [tempTel, setTempTel] = useState("");
  const [tempAdresse, setTempAdresse] = useState("");
  const [tempRegion, setTempRegion] = useState("");

  const [tempStatus, setTempStatus] = useState("");
  const [ficheToutesFiltre, setFicheToutesFiltre] = useState("");
  const [note, setNote] = useState("");

  const [appel, setAppel] = useState("");
  const [date, setDate] = useState(null);
  const [dateValidation, setDateValidation] = useState("");
  const [nbAppels, setNbAppels] = useState("");

  const [selectedEtat, setSelectedEtat] = useState(null);
  const [heureDem, setHeureDem] = useState("");



  const deduireEtatDepuisDates = (rowData) => {
    if (rowData.etat === "3") return "Agenda";
    if (rowData.etat === "2") return "Suivis";
    if (rowData.etat === "1") return "Visite planifiée";
    if (rowData.etat === "4") return "Déménagement";
    if (rowData.etat === "5") return "Abandonnée";
    if (rowData.etat === "6") return "Zotdevis";
    if (rowData.etat === "0" && rowData.nbappels <= "3")
      return "Visite en attente";
    if (rowData.etat === "0" && rowData.nbappels >= "4") return "Abandonnée";
    return "Nouveau";
  };

  const etatOptions = [
    { label: "Visite en attente", value: "0" },
    { label: "Visite planifiée", value: "1" },
    { label: "Suivis", value: "2" },
    { label: "Agenda", value: "3" },
    { label: "Déménagement", value: "4" },
    { label: "Abandonnée", value: "5" },
    { label: "Zotdevis", value: "6" },
  ];

  const getLabel = () => {
    switch (appel) {
      case "0":
        return "Date de la visite";
      case "1":
        return "Date de visite requise";
      case "2":
        return "Date devis requise";
      case "3":
        return "Date validation requise";
      case "4":
        return "Date déménagement requise";
      default:
        return "Date";
    }
  };

  const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error
            );
          });
      } else {
        // Utiliser l'API de sélection de texte comme solution de secours
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    axios
      .get(`${apiUrl}/IHM/api/ficheDem.php?toutes`)
      .then((response) => {
        setFicheToutes(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des factures :", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const recherche = searchTerm.toLowerCase();
    const filteredList = ficheToutes.filter((fiche) => {
      const nom = fiche.nom?.toLowerCase() || "";
      const tel = fiche.tel?.toLowerCase() || "";
      const adresse = fiche.adresse?.toLowerCase() || "";
      const email = fiche.email?.toLowerCase() || "";

      return (
        nom.includes(recherche) ||
        tel.includes(recherche) ||
        adresse.includes(recherche) ||
        email.includes(recherche)
      );
    });
    setFicheToutesFiltre(filteredList);
  }, [searchTerm, ficheToutes]);

  useEffect(() => {
    if (!rechercheId || rechercheId.trim() === "") {
      setFicheToutesFiltre(ficheToutes);
      return;
    }

    const recherche = rechercheId.toLowerCase();

    const filteredList = ficheToutes.filter((fiche) => {
      const idFicheDem = String(fiche.idFicheDem ?? "").toLowerCase();
      return idFicheDem === recherche;
    });

    setFicheToutesFiltre(filteredList);
  }, [rechercheId]);

  useEffect(() => {
    let filteredList = ficheToutes;

    if (selectedUsers && selectedUsers.trim() !== "") {
      const recherche = (selectedUsers?.idUser ?? selectedUsers).toLowerCase();
      filteredList = filteredList.filter((fiche) =>
        String(fiche.adminNote ?? "")
          .toLowerCase()
          .includes(recherche)
      );
    }

    if (selectedEtat) {
      filteredList = filteredList.filter(
        (fiche) => fiche.etat === selectedEtat
      );
    }

    setFicheToutesFiltre(filteredList);
  }, [selectedUsers, selectedEtat, ficheToutes]);

  const enteteTableauNouvelle = () => {
    return (
      <div className="flex justify-content-end">
        <Dropdown
          value={selectedUsers}
          onChange={(e) => setSelectedUsers(e.value)}
          options={users}
          optionLabel="idUser"
          optionValue="idUser"
          placeholder="Séléctionner un utilisateur"
          editable
          style={{
            height: 45,
            border: "none",
            boxShadow: "none",
          }}
        />

        <Dropdown
          value={selectedEtat}
          onChange={(e) => setSelectedEtat(e.value)}
          options={etatOptions}
          placeholder="Sélectionner un état"
          editable
          style={{
            height: 45,
            border: "none",
            boxShadow: "none",
          }}
        />

        <IconField iconPosition="left">
          <InputIcon className="pi pi-hashtag" />
          <InputText
            value={rechercheId}
            onChange={(e) => {
              setRechercheId(e.target.value);
              if (e.target.value) setRechercheToutes("");
            }}
            placeholder="ID"
          />
        </IconField>
{/* 
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={rechercheToutes}
            onChange={(e) => {
              setRechercheToutes(e.target.value);
              if (e.target.value) setRechercheId("");
            }}
            placeholder="Rechercher"
          />
        </IconField> */}

       
      </div>
    );
  };

  const setInfoClick = (idFicheDem, nom, tel, email, adresse, region) => {
    setAppel("");

    setNote("");
    setDate("");

    setTempNom(nom);
    setTempTel(tel);
    setTempEmail(email);
    setTempAdresse(adresse);
    setTempRegion(region);
    setTempIdFicheDem(idFicheDem);

    setHeureDem(null);

    axios
      .get(`${apiUrl}IHM/api/ficheDem.php?idFicheDem=${idFicheDem}`)
      .then((response) => {
        //setNote(response.data[0].note);
        setAppel(response.data[0].etat);
        setTempStatus(response.data[0].status);
        setNbAppels(response.data[0].nbappels);

        if (response.data[0].etat === "1") {
          setDate(new Date(response.data[0].dateVisite));
        } else if (response.data[0].etat === "2") {
          setDate(new Date(response.data[0].dateDevis));
        } else if (response.data[0].etat === "3") {
          setDate(new Date(response.data[0].dateValidation));
        } else if (response.data[0].etat === "4") {
          setDate(new Date(response.data[0].dateDem));
        }

        if (response.data[0].heureDem) {
          setHeureDem(convertTimeStringToDate(response.data[0].heureDem));
        }

        setVisible(true);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération de la fiche :",
          error
        );
      });
  };

  const handleSavePhoneCall = async () => {
    if (!date && appel === "1") {
      alert("La date de visites est obligatoire");
      return;
    } else if (!date && appel === "2") {
      alert("La date d'envoi devis est obligatoire");
      return;
    }

    let data = {
      idFicheDem: tempIdFicheDem,
      etat: appel,
      note: note,
      adminMod: localStorage.getItem("us"),
    };

    const isoDate = formatToISODate(date);
    const isoDateRappel = dateValidation
      ? formatToISODate(dateValidation)
      : null;

    if (appel === "2") {
      data.date = isoDate;
      if (isoDateRappel) data.dateRappel = isoDateRappel;
    } else if (appel === "3") {
      data.dateValidation = isoDate;
      if (isoDateRappel) data.dateRappel = isoDateRappel;
    } else if (appel === "4") {
      const pad = (n) => String(n).padStart(2, "0");

      const heureDemSQL = heureDem
        ? `${pad(heureDem.getHours())}:${pad(heureDem.getMinutes())}:00`
        : null;

      data.dateDemenagement = isoDate;
      data.heureDem = heureDemSQL;
    } else if (appel !== "6") {
      data.date = isoDate;
    }

    try {
      let response;
      if (appel === "6") {
        response = await axios.post(`${apiUrl}IHM/api/zotDevis.php`, {
          idFicheDem: tempIdFicheDem,
          note: note,
          adminMod: localStorage.getItem("us"),
          date: formatToISODate(date),
        });
        if (response.data.success) {
          //alert(response.data.message);
          window.location.reload();
        } else {
          //alert("Erreur : " + response.data.message);
        }
      } else {
        response = await axios.put(`${apiUrl}IHM/api/ficheDem.php`, data);
      }

      if (response.data) {
        setVisible(false);
        window.location.reload();
      } else {
        setVisible(false);
        window.location.reload();
      }
    } catch (error) {
      console.error(
        "Erreur lors de la sauvegarde de l'appel téléphonique",
        error
      );
    }
  };

  useEffect(() => {
    axios
      .get(`${apiUrl}/IHM/api/users.php?AllUsers`)
      .then((response) => {
        const filteredUsers = response.data.filter(
          (user) => !["dev", "admin", "invite"].includes(user.idUser)
        );
        setUsers(filteredUsers);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des utilisateurs :", error);
      });
  }, [apiUrl]);

  const handleValidate = async () => {
    try {
      await axios.post(`${apiUrl}IHM/api/update_ficheDem.php`, {
        idFicheDem: tempIdFicheDem,
        nom: tempNom,
        telephone: tempTel,
        email: tempEmail,
        adresse: tempAdresse,
        region: tempRegion,
      });
      setEditMode(false);
    } catch (error) {
      console.error("Erreur de mise à jour :", error);
      alert("Erreur lors de la sauvegarde");
    } finally {
    }
  };

  const header = (
    <div className="flex justify-between items-center w-full">
      <span className="font-semibold text-lg mr-2">Fiche de déménagement</span>
      <div className="flex items-center gap-2">
        <span style={{ cursor: "pointer" }}>
          {editMode ? (
            <>
              <span
                onClick={() => handleValidate()}
                style={{
                  border: "1px solid #22c55e",
                  borderRadius: "50%",
                  color: "#fff",
                  width: "28px",
                  height: "28px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  marginRight: "8px",
                  transition: "all 0.2s ease",

                  backgroundColor: "#22c55e",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#22c55e";
                  e.currentTarget.style.color = "#fff";
                }}
              >
                <CheckIcon sx={{ fontSize: 16 }} />
              </span>

              <span
                onClick={() => setEditMode(false)}
                style={{
                  border: "1px solid #ef4444",
                  borderRadius: "50%",
                  color: "#ffffffff",
                  width: "28px",
                  height: "28px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  backgroundColor: "#ef4444",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#ef4444";
                  e.currentTarget.style.color = "#fff";
                }}
              >
                <CloseIcon sx={{ fontSize: 16 }} />
              </span>
            </>
          ) : (
            <span
              style={{
                border: "1px solid #4b5563",
                borderRadius: "50%",
                color: "#ffffffff",
                width: "28px",
                height: "28px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                marginRight: "8px",
                transition: "all 0.2s ease",
                backgroundColor: "#4b5563",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#4b5563";
                e.currentTarget.style.color = "#fff";
              }}
              onClick={() => setEditMode(true)}
            >
              {" "}
              <EditIcon sx={{ fontSize: 16 }} />{" "}
            </span>
          )}
        </span>
      </div>
    </div>
  );

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={`Copie réussie de " ${
          copiedText === "location.mail" ? "e-mail" : copiedText
        } "`}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Dialog
        blockScroll
        visible={visible}
        header={header}
        className="custom-dialog"
        style={{ width: "40vw" }}
        modal
        onHide={() => {
          setVisible(false);
          setEditMode(false);
        }}
        breakpoints={{ "960px": "100vw", "640px": "100vw" }}
      >
        <div className="p-3">
          <div className="grid">
            {/* Etat actuel */}
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                <span className="font-bold">État actuel :</span>
                <span
                  className="p-1 px-2 text-sm"
                  style={{ background: "#e5e7eb", borderRadius: "5px" }}
                >
                  {tempStatus}{" "}
                  <small>
                    <small>({nbAppels})</small>
                  </small>
                </span>
              </div>
            </div>

            {/* Etat souhaité */}
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                <span className="font-bold">État souhaité :</span>
                <Select
                  labelId="etat-label"
                  id="etat-select"
                  value={appel}
                  onChange={(e) => setAppel(e.target.value)}
                  displayEmpty
                  style={{
                    minWidth: "130px",
                    maxWidth: "130px",
                    maxHeight: "20px",
                  }}
                >
                  <MenuItem value="" disabled>
                    Séléctionner un état
                  </MenuItem>
                  <MenuItem value="0">Visites</MenuItem>
                  <MenuItem value="1">Devis</MenuItem>
                  <MenuItem value="2">Suivis</MenuItem>
                  <MenuItem value="3">Agenda</MenuItem>
                  <MenuItem value="4">Déménagement</MenuItem>
                  <MenuItem value="5">Abandonné</MenuItem>
                  <MenuItem value="6">Vers Zotdevis</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          {/* Ligne 1 */}
          <div className="grid">
            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Nom :</span>

                {editMode ? (
                  <InputText
                    value={tempNom}
                    onChange={(e) => setTempNom(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempNom)}
                    className="cursor-pointer"
                  >
                    {tempNom} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>

            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Email :</span>

                {editMode ? (
                  <InputText
                    value={tempEmail}
                    onChange={(e) => setTempEmail(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempEmail)}
                    className="cursor-pointer"
                  >
                    {tempEmail} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Ligne 2 */}
          <div className="grid">
            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Téléphone :</span>

                {editMode ? (
                  <InputText
                    value={tempTel}
                    onChange={(e) => setTempTel(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempTel)}
                    className="cursor-pointer"
                  >
                    {tempTel} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>

            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Région :</span>

                {editMode ? (
                  <InputText
                    value={tempRegion}
                    onChange={(e) => setTempRegion(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempRegion)}
                    className="cursor-pointer"
                  >
                    {tempRegion} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Ligne 3 */}
          <div className="grid">
            <div className="col-12">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Adresse :</span>
                {editMode ? (
                  <InputText
                    value={tempAdresse}
                    onChange={(e) => setTempAdresse(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempAdresse)}
                    className="cursor-pointer"
                  >
                    {tempAdresse} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Ligne Date optionnel*/}
          {(appel === "1" ||
            appel === "2" ||
            appel === "3" ||
            appel === "4") && (
            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="p-2 px-0 border-round-sm surface-100 flex flex-column gap-2 px-0">
                  <span className="font-bold">{getLabel()}</span>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={fr}
                  >
                    <DatePicker
                      value={date}
                      onChange={(newValue) => setDate(newValue)}
                      renderInput={(props) => (
                        <TextField {...props} fullWidth />
                      )}
                      inputFormat="dd/MM/yyyy"
                      minDate={new Date()}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
          )}

          {(appel === "2" || appel === "3") && (
            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="p-2 px-0 border-round-sm surface-100 flex flex-column gap-2 px-0">
                  <span className="font-bold">Date de rappel </span>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={fr}
                  >
                    <DatePicker
                      value={dateValidation}
                      onChange={(newValue) => setDateValidation(newValue)}
                      renderInput={(props) => (
                        <TextField {...props} required="false" fullWidth />
                      )}
                      inputFormat="dd/MM/yyyy"
                      minDate={new Date()}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
          )}

          {appel === "4" && (
            <>
              <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                <span className="font-bold">Heure du déménagement:</span>
              </div>
              <div className="grid">
                <div className="col-12 md:col-12">
                  <Calendar
                    id="calendar-timeonly"
                    value={heureDem}
                    onChange={(e) => setHeureDem(e.value)}
                    timeOnly
                    showSeconds={false}
                    inputMode="none"
                    style={{
                      width: "100%",
                      borderRadius: "5px",
                      border: "1px solid #000",
                    }}
                    className="mt-2"
                  />
                </div>
              </div>
            </>
          )}

          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                <span className="font-bold">Ajouter une note :</span>
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="col-12 md:col-12">
              <TextareaAutosize
                variant="standard"
                minRows={5}
                maxRows={10}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                style={{ width: "100%", borderRadius: "5px" }}
                className="mt-2"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="border-round-sm surface-100 flex flex-column"></div>
              <Button
                label="Enregistrer l'état et la note"
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#094ed8";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#2563eb";
                }}
                className="w-full text-white"
                style={{
                  background: "#094ed8",
                  border: "1px solid #094ed8",
                  padding: "0.75rem",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  if (appel) {
                    handleSavePhoneCall();
                  }
                }}
              />
            </div>
          </div>

          <FicheLogTerminal idFicheDem={tempIdFicheDem} />
        </div>
      </Dialog>

      <DataTable
        value={ficheToutesFiltre}
        paginator
        size="small"
        rows={25}
        header={enteteTableauNouvelle}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        scrollDirection="horizontal"
        paginatorTemplate={
          "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
        }
        paginatorRight={
          <span style={{ margin: "10px", fontWeight: "bold" }}>
            Résultats : {ficheToutesFiltre.length}
          </span>
        }
        loading={loading}
        loadingIcon="pi pi-spin pi-spinner"
        emptyMessage={
          loading ? "Chargement des fiches..." : "Aucune fiche pour le moment"
        }
      >
        <Column
          field="dateFicheDemande"
          header="Date"
          body={(rowData) => formatDateWithDaysAgo(rowData.dateFicheDem)}
        />

        <Column
          field="nom"
          header="Client"
          body={(rowData) => nameTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="email"
          header="Contact"
          body={(rowData) => contactTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="etat"
          header="Statut"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            // Utiliser l'état fourni, ou le déduire à partir des dates
            const etatFinal = deduireEtatDepuisDates(rowData);
            const label = `${mapEtatFicheDem(etatFinal)}`;
            const severity = rowData.severity || "info";

            return (
              <div>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Tag
                    value={label}
                    style={{
                      backgroundColor: rowData.color,
                      color: "#fff",
                      padding: "4px 12px",
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  ></Tag>
                </span>
              </div>
            );
          }}
        />

        <Column
          field="tel"
          header="Dernier MAJ"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            if (!rowData.dateUpdate) return null;

            const date = new Date(rowData.dateUpdate);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return (
              <span>
                {formatDateTimeMadagascar(rowData.dateUpdate)}{" "}
                {rowData.nbappels !== undefined && (
                  <small>
                    <small>({rowData.nbappels})</small>
                  </small>
                )}
                <br />
                {rowData.adminNote}
              </span>
            );
          }}
        />

        <Column
          header="Actions"
          style={{ textAlign: "center", width: "100px" }}
          body={(rowData) => (
            <div>
              <Button
                icon="pi pi-phone"
                severity="success"
                size="small"
                text
                raised
                onClick={() => {
                  setInfoClick(
                    rowData.idFicheDem,
                    rowData.nom,
                    rowData.tel,
                    rowData.email,
                    rowData.adresse,
                    rowData.region,
                  );
                }}
              />
            </div>
          )}
        />
      </DataTable>
    </>
  );
}
